<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <strong>Wallet-Design</strong>
    <div class="custom-control custom-switch" *ngIf="analysis">
      <input type="checkbox" class="custom-control-input" id="wallet_design_enabled"
             [checked]="enabled" (change)="toggleEnabled($event.target.checked)">
      <label class="custom-control-label" for="wallet_design_enabled">Aus Druckvorlage erstellen</label>
    </div>
  </div>

  <div class="card-body">
    <p class="text-muted mb-0" *ngIf="loading">Druckvorlage wird analysiert …</p>
    <div class="alert alert-danger mb-0" *ngIf="error">{{ error }}</div>

    <div class="row" *ngIf="analysis && settings && enabled">
      <div class="col-6">
        <div class="form-group" *ngIf="analysis.pages.length > 1">
          <label>Seite</label>
          <div class="d-flex flex-wrap">
            <button type="button" class="option option-page" *ngFor="let page of analysis.pages"
                    [class.active]="settings.page === page.index" (click)="selectPage(page.index)">
              <img [src]="page.image" alt="Seite {{ page.index + 1 }}">
              <span class="small">Seite {{ page.index + 1 }}</span>
              <span class="badge badge-secondary" *ngIf="page.back_side">Rückseite erkannt</span>
            </button>
          </div>
        </div>

        <div class="form-group">
          <label>Ausrichtung</label>
          <small class="form-text text-muted mt-0 mb-1">Die Variante wählen, in der die Schrift aufrecht steht.</small>
          <div class="d-flex flex-wrap">
            <button type="button" class="option option-rotation" *ngFor="let rotation of rotations"
                    [class.active]="settings.rotation === rotation" (click)="selectRotation(rotation)">
              <span class="rotation-frame">
                <img [src]="page.image" [style.transform]="'rotate(' + rotation + 'deg)'" alt="{{ rotation }}°">
              </span>
              <span class="small">{{ rotation }}°</span>
            </button>
          </div>
        </div>

        <div class="form-group">
          <label>Layout</label>
          <div class="list-group">
            <button type="button" class="list-group-item list-group-item-action" *ngFor="let layout of layouts"
                    [class.active]="settings.layout === layout.value" [disabled]="layoutDisabled(layout.value)"
                    (click)="selectLayout(layout.value)">
              <strong>{{ layout.label }}</strong>
              <small class="d-block">
                {{ layoutDisabled(layout.value) ? 'Nicht verfügbar für Hochformat-Karten' : layout.hint }}
              </small>
            </button>
          </div>
        </div>

        <div class="form-group" *ngIf="settings.layout !== 'colors_only'">
          <label for="wallet_design_zoom">Zoom: {{ settings.zoom | number:'1.2-2' }}×</label>
          <input type="range" class="custom-range" id="wallet_design_zoom" min="0.5" max="2" step="0.05"
                 [value]="settings.zoom" (input)="setZoom($event.target.value)">
        </div>

        <div class="form-row">
          <div class="col-6">
            <label for="wallet_design_background">Hintergrund</label>
            <input type="color" class="form-control" id="wallet_design_background"
                   [value]="settings.background_color" (input)="setColor('background_color', $event.target.value)">
          </div>
          <div class="col-6">
            <label for="wallet_design_text">Schrift (Apple)</label>
            <input type="color" class="form-control" id="wallet_design_text"
                   [value]="settings.text_color" (input)="setColor('text_color', $event.target.value)">
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <small [class.text-danger]="contrastRatio < 3" [class.text-muted]="contrastRatio >= 3">
            Kontrast {{ contrastRatio | number:'1.1-1' }}:1{{ contrastRatio < 3 ? ' – schwer lesbar' : '' }}
          </small>
          <button type="button" class="btn btn-sm btn-link" (click)="resetColors()">Erkannte Farben</button>
        </div>
      </div>

      <div class="col-6">
        <label>Vorschau</label>
        <div class="d-flex previews">
          <div class="preview-column">
            <small class="text-muted">Apple Wallet</small>
            <div class="pass pass-apple" [style.background]="settings.background_color" [style.color]="settings.text_color">
              <div class="pass-apple-header">
                <img class="pass-apple-logo" [src]="squareLogoUrl" alt="">
                <span class="pass-apple-title">{{ title || 'Partner' }}</span>
                <span class="pass-field pass-field-right">
                  <span class="pass-label">PUNKTE</span>
                  <span class="pass-value">42</span>
                </span>
              </div>
              <img class="pass-strip" *ngIf="stripUrl" [src]="stripUrl" alt="">
              <div class="pass-apple-fields">
                <span class="pass-field">
                  <span class="pass-label">STATUS</span>
                  <span class="pass-value">Treuer Kunde</span>
                </span>
                <span class="pass-field">
                  <span class="pass-label">LETZTER BESUCH</span>
                  <span class="pass-value">30.09.2026</span>
                </span>
              </div>
              <div class="pass-qr"></div>
            </div>
          </div>

          <div class="preview-column">
            <small class="text-muted">Google Wallet</small>
            <div class="pass pass-google" [style.background]="settings.background_color" [style.color]="googleTextColor">
              <div class="pass-google-header">
                <img class="pass-google-logo" [src]="squareLogoUrl" alt="">
                <span>Mankido</span>
              </div>
              <div class="pass-google-title">{{ title || 'Partner' }}</div>
              <div class="pass-google-fields">
                <span class="pass-field">
                  <span class="pass-label-google">Punkte</span>
                  <span class="pass-value-google">42</span>
                </span>
                <span class="pass-field pass-field-right">
                  <span class="pass-label-google">Status</span>
                  <span class="pass-value-google">Treuer Kunde</span>
                </span>
              </div>
              <div class="pass-qr pass-qr-google"></div>
              <img class="pass-hero" *ngIf="stripUrl" [src]="stripUrl" alt="">
            </div>
            <small class="text-muted d-block mt-1">Google wählt die Schriftfarbe automatisch.</small>
          </div>
        </div>
      </div>
    </div>

    <p class="text-muted mb-0" *ngIf="analysis && !enabled">
      Für diese Bestellung wird kein Wallet-Design gespeichert.
    </p>
  </div>
</div>
